import { ROBLOX_MATERIALS, RobloxMaterial } from '../types'

/**
 * looks_brickColors ドロップダウン値 → CSS 16 進カラー。
 * Roblox の BrickColor パレット（BrickColor.White() 等）の RGB に合わせる。
 * 子どもが選べる 8 色（looks.ts の looks_brickColors と一致）。
 */
export const BRICK_COLOR_HEX: Readonly<Record<string, string>> = {
  White: '#F2F3F3',
  Gray: '#A3A2A5',
  DarkGray: '#635F62',
  Black: '#1B2A35',
  Red: '#C4281C',
  Yellow: '#F5CD30',
  Green: '#4B974B',
  Blue: '#0D69AC',
}

/**
 * Material 名 → preview の RobloxMaterial への写像。
 * 全マテリアルを固有の模様・質感で描き分けるため、原則そのまま通す。
 * 例外: ドロップダウンの 'Cupboard' は実在しない Enum 名（正しくは
 * Cardboard＝段ボール）のため Cardboard として扱う。未知名は Plastic。
 */
const MATERIAL_ALIASES: Readonly<Record<string, RobloxMaterial>> = {
  Cupboard: 'Cardboard',
}

const SUPPORTED_MATERIALS: ReadonlySet<string> = new Set(ROBLOX_MATERIALS)

const isSupportedMaterial = (name: string): name is RobloxMaterial =>
  SUPPORTED_MATERIALS.has(name)

export const toRobloxMaterial = (name: string): RobloxMaterial => {
  if (isSupportedMaterial(name)) {
    return name
  }
  return MATERIAL_ALIASES[name] ?? 'Plastic'
}
